module.exports = __webpack_public_path__ + "img/car_shina2_06.8bfebeb2.jpg";